import { render, staticRenderFns } from "./ProfitLoss_.vue?vue&type=template&id=0dd20462&scoped=true&"
import script from "./ProfitLoss_.vue?vue&type=script&lang=ts&"
export * from "./ProfitLoss_.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitLoss_.vue?vue&type=style&index=0&id=0dd20462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd20462",
  null
  
)

export default component.exports